import React, { useState, useEffect, useRef } from "react";
import appBgGradient from '../../../assets/app_launchscreen.png';
import appLogo from '../../../assets/anytrakk.png';
import { getOTP, registerUser } from './action.ts'
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom'; 

import 'react-toastify/dist/ReactToastify.css';
import './register_style.scss';

const RegisterScreen = () => {
  const [fullName, setFullName] = useState("");
  const [countryCode, setCountryCode] = useState("+91");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [otpCode, setOtpCode] = useState("");
  const [tPin, setTPin] = useState("");
  const [confirmPin, setConfirmPin] = useState("");
  const [showCountryPicker, setShowCountryPicker] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingOTP, setLoadingOTP] = useState(false);
  const [otpGenerated, setOtpGenerated] = useState(false);
  const [error, setError] = useState('');
    const navigate = useNavigate();
  
  const [deviceId, setDeviceId] = useState('');
  const [fcmToken, setFcmToken] = useState('');
  const [phoneNumberError, setPhoneNumberError] = useState(false);
  const otpRefs = [
    useRef<HTMLInputElement>(null),
    useRef<HTMLInputElement>(null),
    useRef<HTMLInputElement>(null),
    useRef<HTMLInputElement>(null)
  ];
  const pinRefs = [
    useRef<HTMLInputElement>(null),
    useRef<HTMLInputElement>(null),
    useRef<HTMLInputElement>(null),
    useRef<HTMLInputElement>(null)
  ];
  const confirmPinRefs = [
    useRef<HTMLInputElement>(null),
    useRef<HTMLInputElement>(null),
    useRef<HTMLInputElement>(null),
    useRef<HTMLInputElement>(null)
  ];
  const tapOnSendOTP = () => {
    if (!phoneNumber) {
      toast.error("Phone number is required");
      setPhoneNumberError(true);
    } else if (phoneNumber.length < 10) {
      toast.error("Phone number must be 10 digits");
      setPhoneNumberError(true);
    } else {
      sendOTPAPI();
    }
  };
  const sendOTPAPI =() => {
    getOTP(phoneNumber, '91', '1',
      (response) => {
        if (response.data.status === 200) {
          setOtpGenerated(true);
          toast.success("OTP Sent");
        } else {
          toast.error(response.data.message);
        }
      },
      (errorMessage) => {
        toast.error(errorMessage.message || 'Failed to send OTP. Please try again.');
      }
    );
  };
  const handlePhoneNumberBlur = () => {
    if (phoneNumber && phoneNumber.length < 10) {
      toast.error("Phone number must be 10 digits");
      setPhoneNumberError(true);
    } else {
      setPhoneNumberError(false);
    }
  };
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const urlDeviceId = queryParams.get('device_id');
    const urlFcmToken = queryParams.get('fcm_token');
    if (urlDeviceId) {
      setDeviceId(urlDeviceId);
    }
    if (urlFcmToken) {
      setFcmToken(urlFcmToken);
    }
  }, []);
  const registerPressHandler = () => {
    if (!fullName) {
      toast.error("Full name is required");
    } else if (!phoneNumber) {
      toast.error("Phone number is required");
    } else if (phoneNumber.length !== 10) {
      toast.error("Phone number must be 10 digits");
    // } else if (!otpGenerated) {
    //   toast.error("Please generate OTP first");
    // } else if (!otpCode || otpCode.length < 4) {
    //   toast.error("Please enter a valid OTP");
    } else if (!tPin || tPin.length < 4) {
      toast.error("Please set up your 4-digit PIN");
    } else if (!confirmPin || confirmPin.length < 4) {
      toast.error("Please confirm your 4-digit PIN");
    } else if (confirmPin !== tPin) {
      toast.error("PINs do not match");
    } else {
      registerUser(fullName, phoneNumber, '91', tPin, confirmPin, otpCode, deviceId,fcmToken, (response) => {
        if (response.data.status === 200) {
          toast.success(response.data.message);
          if ((window as any).ReactNativeWebView) {
            const message = {
              type: 'LOGIN_SUCCESS',
              data: {
                token: response.data.token,
                user: response.data.user,
                role: response.data.role,
              }
            };
            
           (window as any).ReactNativeWebView.postMessage(JSON.stringify(message));
          }
        } else {
          toast.error(response.data.message);
        }
      },
        (errorMessage) => {
          toast.error(errorMessage.message);
        })
    }
  };
  const countries = [
    { name: "India", dial_code: "+91", code: "IN" },
    { name: "United States", dial_code: "+1", code: "US" },
    { name: "United Kingdom", dial_code: "+44", code: "GB" },
  ];
  return (
    <div className="register-container" style={{
      background: `url(${appBgGradient}) no-repeat center center fixed`,
      backgroundSize: 'cover'
    }}>
      <div className="register-inner">
        <div className="logo-container">
          <img src={appLogo} alt="App Logo" className="logo" />
        </div>
        <div className="white-card">
          <div className="title-container">
            <h2 className="title">Register</h2>
          </div>
          <div className="input-group">
            
            <input
              id="fullName"
              className="input"
              type="text"
              placeholder="Enter your full name"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
            />
          </div>
          <div className="input-group">
            <div className="phone-input-wrapper">
              <button className="country-button"
                onClick={() => setShowCountryPicker(!showCountryPicker)}>
                {countryCode}
              </button>
              <input 
                className={`input phone-input ${phoneNumberError ? 'error' : ''}`} 
                placeholder="Enter Mobile Number" 
                type="tel"
                value={phoneNumber}
                onChange={(e) => {
                  const filtered = e.target.value.replace(/\D/g, '');
                  setPhoneNumber(filtered.slice(0, 10));
                  if (filtered.length === 10) {
                    setPhoneNumberError(false);
                  }
                }}
                onBlur={handlePhoneNumberBlur}
              />
              <button 
                className={`otp-button ${(loadingOTP || phoneNumber.length !== 10) ? 'disabled' : ''}`} 
                onClick={tapOnSendOTP} 
                disabled={loadingOTP || phoneNumber.length !== 10}
              >
                {loadingOTP ? "Sending..." : "Get OTP"}
              </button>
            </div>
          </div>
          {showCountryPicker && (
            <div className="country-picker">
              {countries.map((country) => (
                <div key={country.code} className="country-item"
                  onClick={() => {
                    setCountryCode(country.dial_code);
                    setShowCountryPicker(false);
                  }}>
                  {country.name} ({country.dial_code})
                </div>
              ))}
            </div>
          )}
          <div className="input-row">
            <label className="label-inline">OTP</label>
            <div className="otp-wrapper">
              {[0, 1, 2, 3].map((index) => (
                <input
                  key={index}
                  ref={otpRefs[index]}
                  className="otp-input"
                  type="text"
                  maxLength={1}
                  value={otpCode[index] || ""}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    if (value.length > 0 && index < 3) {
                      otpRefs[index + 1].current?.focus();
                    }
                    const newOtp = otpCode.split("");
                    newOtp[index] = value;
                    setOtpCode(newOtp.join("").slice(0, 4));
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Backspace" && !otpCode[index] && index > 0) {
                      otpRefs[index - 1].current?.focus();
                    }
                  }}
                />
              ))}
            </div>
          </div>
          <div className="input-group">
            <label className="label">Set PIN</label>
            <div className="otp-wrapper">
              {[0, 1, 2, 3].map((index) => (
                <input
                  key={index}
                  ref={pinRefs[index]}
                  className="otp-input"
                  type="number"
                  maxLength={1}
                  value={tPin[index] || ''}
                  onChange={(e) => {
                    const val = e.target.value.replace(/\D/g, '');
                    const newPin = tPin.split('');
                    newPin[index] = val;
                    setTPin(newPin.join('').slice(0, 4));
                    if (val && index < 3) pinRefs[index + 1].current?.focus();
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Backspace' && !tPin[index] && index > 0) {
                      pinRefs[index - 1].current?.focus();
                    }
                  }}
                />
              ))}
            </div>
          </div>
          <div className="input-group">
            <label className="label">Confirm PIN</label>
            <div className="otp-wrapper">
              {[0, 1, 2, 3].map((index) => (
                <input
                  key={index}
                  ref={confirmPinRefs[index]}
                  className="otp-input"
                  type="number"
                  maxLength={1}
                  value={confirmPin[index] || ''}
                  onChange={(e) => {
                    const val = e.target.value.replace(/\D/g, '');
                    const newPin = confirmPin.split('');
                    newPin[index] = val;
                    setConfirmPin(newPin.join('').slice(0, 4));
                    if (val && index < 3) confirmPinRefs[index + 1].current?.focus();
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Backspace' && !confirmPin[index] && index > 0) {
                      confirmPinRefs[index - 1].current?.focus();
                    }
                  }}
                />
              ))}
            </div>
          </div>
          <button className="register-button" onClick={registerPressHandler} disabled={isLoading}>
            {isLoading ? "Registering..." : "Register"}
          </button>
        </div>
                <div className="policy-text">
          <label>
            <a
              href="/wv/privacy_policy"
              className="policy-link"
            >
              Privacy Policy
            </a>{" "}
            and{" "}
            <a
              href="/wv/terms_of_service"
              className="policy-link"
            >
              Terms of Service
            </a>{" "}
            apply.
          </label>
        </div>
        <div className="footer">
          <p className="footer-text"></p>
        </div>
      </div>
    </div>
  );
};

export default RegisterScreen;